import { motion } from 'framer-motion'
import { memo } from 'react'

import { GeneralInfo } from '@widgets/generalInfo'
import { MealsList } from '@widgets/mealsList'

import { useTgData } from '@shared/lib/useTgData'

const MainPage = () => {
  // eslint-disable-next-line no-unused-vars
  const tgData = useTgData()

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <GeneralInfo />
      <MealsList />
    </motion.div>
  )
}

export default memo(MainPage)
